import { render, staticRenderFns } from "./WorkDetail15.vue?vue&type=template&id=7b7828b9&scoped=true&"
import script from "./WorkDetail15.vue?vue&type=script&lang=js&"
export * from "./WorkDetail15.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetail15.vue?vue&type=style&index=0&id=7b7828b9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7828b9",
  null
  
)

export default component.exports